export default {
    s: {
        gameDiameter: 20,
        gameCoord: {
            x: 87,
            y: 214,
        },
    },
    m: {
        gameDiameter: 32,
        gameCoord: {
            x: 241,
            y: 361,
        },
    },
    l: {
        gameDiameter: 32,
        siteDiameter: 48,
        gameCoord: {
            x: 141,
            y: 184,
        },
        siteCoord: {
            research: {
                x: 660,
                y: 489,
            },
            design: {
                x: 843,
                y: 336,
            },
            launch: {
                // x: 902,
                x: 890,
                y: 571,
            },
        },
    },
    xl: {
        gameDiameter: 40,
        siteDiameter: 64,
        gameCoord: {
            x: 177,
            y: 222,
        },
        siteCoord: {
            research: {
                x: 859,
                y: 535,
            },
            design: {
                x: 1071,
                y: 351,
            },
            launch: {
                x: 1243,
                y: 647,
            },
        },
    },
};
